import {Typography} from '../typography'
import {Box} from '../box'

import * as classes from './BusinessBadge.classes'

export function BusinessBadge({children}: {children: string}) {
  return (
    <Box className={classes.box}>
      <Typography color="invert" thickness="medium" variant="caption2">
        {children}
      </Typography>
    </Box>
  )
}
